import { FetchRequest } from "@rails/request.js"

// JSON-Aufruf an Rails mit CSRF-Token und Session-Cookie (request.js, die Fetch-Hülle von Rails; Turbo hat keine
// öffentliche). Gibt die geparste Antwort zurück (null ohne Inhalt) oder wirft mit dem Fehlertext des Servers
// ({error: "…"}) bzw. dem HTTP-Status; der Fehler trägt kind "server" (Fehlerart im Produktionsprotokoll).
// responseKind "turbo-stream": eine Stream-Antwort wendet request.js selbst an (Turbo.renderStreamMessage), Fehler kommen
// weiter als JSON.
export async function requestJson(method, url, body, responseKind = "json") {
  const request = new FetchRequest(method, url, { body, responseKind })
  const response = await request.perform()
  const data = response.statusCode === 204 || response.isTurboStream ? null : await response.json.catch(() => null)
  if (!response.ok) throw Object.assign(new Error(data?.error ?? `HTTP ${response.statusCode}`), { kind: "server" })
  return data
}

export const getJson = (url) => requestJson("get", url)
export const postJson = (url, body = {}) => requestJson("post", url, body)
export const postForStream = (url, body = {}) => requestJson("post", url, body, "turbo-stream")
